export default __webpack_public_path__ + "static/media/operation.ef862e20.svg";